import { render, staticRenderFns } from "./DashboardLayout.vue?vue&type=template&id=0034613f&scoped=true"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"
import style0 from "./DashboardLayout.vue?vue&type=style&index=0&id=0034613f&prod&lang=scss"
import style1 from "./DashboardLayout.vue?vue&type=style&index=1&id=0034613f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0034613f",
  null
  
)

export default component.exports